import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf } from '../../data/utils/classIf';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { PrematchContext } from '../Prematch';
import { SeoContext } from '../../data/seo/SeoContextProvider';


function MenuCategoryItem(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const icoCategory = iconCategoryCssClass(props.sportRef,props.categoryRef,props.iconClass);
    //const absoluteCategoryPath = useAbsolutePath([props.urlPath, props.urlPathSuffix].join(''),null,props.urlPathSeo,false);
    const relativeCategoryPath = useAbsolutePath([props.urlPath, props.urlPathSuffix].join(''),null,props.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);
   
    function handleClickHref(e){
        e.preventDefault();
        if(props.action)
            props.action();
    }

    function toggleFavorite(e) {
        e.preventDefault();
        e.stopPropagation();
        prematchContext.toggleFavoriteTournament(tournamentUniqueId);
    }

    function handleOnClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            if(props.action){
                props.action();
            }
        }else{
            appContext.setHandleOpenFromPath(true);
        }
    }

    const tournamentUniqueId = `${props.sportRef}_${props.categoryRef}_${props.id}`;

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
       /*  <a  href={encodeURI(absoluteCategoryPath)} className="list-element striped" onClick={handleClickHref.bind(this)}> */
        <Link to={encodeURI(relativeCategoryPath) } id={`category-item-${props.categoryRef}`} className="list-element striped" onClick={handleOnClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
            <div className={`prematch-sport-img big ${icoCategory}`}></div>
            <span className="list-element-text">{props.desc}</span>
            <div className="d-flex push-right mr-2">
                {props.isLive &&
                    <div className="badge-live mr-2"></div>
                }
                <span className="list-element-info">{props.info}</span>
                {props.showPinToggle &&
                    <div className="pin-toggle" onClick={toggleFavorite}>
                        <i className={"fas fa-thumbtack rotate-45" + classIf(prematchContext.favoriteTournaments[tournamentUniqueId] === true, 'selected')}></i>
                    </div>
                }
            </div>
            <span className="arrow arrow-right"></span>
        </Link>
        /* </a> */
    );
}

export default MenuCategoryItem;